<template>
    <nav class="navbar navbar-light">
        <div class="navbar-menu-wrapper d-flex align-items-center">
            <ul class="navbar-nav ml-lg-auto">
               
                <li class="nav-item dropdown">
                    <a class="nav-link count-indicator" id="notificationDropdown" href="#" data-toggle="dropdown">
                        <i class="mdi mdi-bell-outline"></i>
                        <span class="count bg-warning" v-if="newnotifications && newnotifications.length>0"> {{newnotifications.length}} </span>
                    </a>
                    <div v-if="newnotifications"
                         style="min-width: 15rem!important; padding-bottom: 0rem!important;"
                         class="dropdown-menu navbar-dropdown notification-drop-down pt-0"
                         aria-labelledby="notificationDropdown" >
                        <a class="dropdown-item" v-for="(item, index) in newnotifications" v-bind:key="index" href="#" style="padding: 0px 11px!important;">
                            <div class="row" >
                                <div class="col-12 pt-4">
                                    <span class="notification-text">{{item._title}}</span>
                                    <div style="font-size: x-small" class="notification-text">{{getformatDate(item._created_at)}}</div>
                                </div>
                            </div>
                        </a>

                        <v-footer  padless >
                            <v-card class="flex" flat tile >
                                    <router-link class="nav-link" :to="{name:'notifications'}">
                                        <v-card-text class="py-2  text-center text-uppercase" >
                                            <strong class="text-uppercase">{{$t('see_all')}}</strong>
                                        </v-card-text>
                                    </router-link>

                                </v-card>
                        </v-footer>

                    </div>
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link" id="languageDropdown" href="#" data-toggle="dropdown">
                        <i class="mdi mdi-google-translate"></i> <span style="font-size: medium;margin-top:-3px" class="language-text text-uppercase"> {{userLocale.name}} </span>
                    </a>
                    <div style="min-width: 15rem!important; padding-bottom: 0rem!important;" class="dropdown-menu navbar-dropdown notification-drop-down" aria-labelledby="languageDropdown" >
                        <a class="dropdown-item" v-for="langue in langues" :key="langue._id"  href="#" @click="changeLanguage(langue)" style="padding: 0px 11px!important;">
                            <div class="row" >
                                <div class="col-12 pt-4">
                                    <div style="font-size: medium">{{langue._name}}</div>
                                </div>
                            </div>
                        </a>
                    </div>
                </li>
                <li class="nav-item">
                    <a href="#" @click="logout()" style="margin-top: -3px !important;" class="nav-link"> <v-icon >mdi-power-standby</v-icon></a>
                </li>
            </ul>
            <button @click="toggleSidebar" class="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" data-toggle="offcanvas">
                <span class="navbar-toggler-icon"></span>
            </button>
        </div>
    </nav>
</template>
<script>
    import {mapState} from "vuex";
    import { EventBus } from '../../router/eventBus'
    export default {
        name: "sidebar",
        methods:{
            toggleSidebar() {
      EventBus.$emit('toggle-sidebar'); // Emit an event when the button is clicked
        },
            getformatDate(value) {
                if (value) {
                    return Intl.DateTimeFormat('fr-FR', {
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit',
                        hour: "numeric",
                        minute: "2-digit",
                        second: "2-digit"
                    }).format(new Date(value));
                }
            },
            changeLanguage(langue){
                    localStorage.setItem('locale',JSON.stringify({name:langue._name,locale:langue._code}))
                    location.reload();
            }

        }, computed: {
            formTitle() {
                return this.editedIndex === -1 ? this.$t('countries.new') : this.$t('countries.update')
            },
            userLocale(){
                return JSON.parse(localStorage.getItem('locale'))
            },
            ...mapState('notifications/', ['newnotifications']),
            ...mapState('langues/',['langues'])

        }
        ,
        mounted() {
            this.$store.dispatch('langues/getLangues').then(()=>{});
            let marchanId = (this.$store.getters.marchand)?this.$store.getters.marchand._id:"";
            this.$store.dispatch('notifications/getNewNotifications',marchanId).then(() => {
            });
        }
        ,
    }
</script>

<style scoped>
.deconnexion{
    font-size: 20pt;
    margin-left: 6px;
    color: #000;
}
.flagLog{
    margin-left: 12px;
    font-size: 20pt;
}
.notification-text{
    color:dimgray
}
</style>
